// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2hp1U","info":"UpdateTermsInfo_info__1qdOg"};